import { useCallback } from 'react'
import { useUpdateTopViewContext } from '../../view-atoms'

/**
 * Open the Action View's chat drawer by flipping the top action entry into its
 * chat state (HIG-5977). A no-op unless an Action View entry is on top with
 * the drawer closed — every caller (the submit hook, the busy pill's jump, the
 * composer's resume row) only renders in exactly that situation.
 */
export function useOpenActionChatDrawer(): () => void {
  const updateActionContext = useUpdateTopViewContext('action')
  return useCallback(
    () => updateActionContext((prev) => (prev && !prev.chat ? { ...prev, chat: true } : prev)),
    [updateActionContext],
  )
}

/**
 * The inverse: dismissing the drawer (scrim click, swipe-down, Escape) lands
 * back on the plain Action View by flipping the same entry.
 */
export function useDismissActionChatDrawer(): () => void {
  const updateActionContext = useUpdateTopViewContext('action')
  return useCallback(
    () => updateActionContext((prev) => (prev?.chat ? { ...prev, chat: false } : prev)),
    [updateActionContext],
  )
}
